import { combineReducers } from 'redux';
import { licensesReducer, clientsReducer } from './clients/duck/reducers';
import { usersReducer, inviteReducer } from './users/duck/reducers';
import { loginReducer } from './login/duck/reducers';

export default () => combineReducers({
  licensesReducer,
  clientsReducer,
  usersReducer,
  inviteReducer,
  loginReducer,
});
